import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/checkinRewards/currency.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "bannerContainer" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "checkin_container" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text_2" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "text_2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 2,
  class: "bottom_text"
}
const _hoisted_12 = { class: "title" }

import CustomHeader from '../components/common/customHeader.vue';
import { ref } from 'vue';
import CheckinPopup from './components/checkinPopup.vue';
import VerifyPhonePopup from './components/verifyPhonePopup.vue';
import { CheckingRewardData } from '@/view/checkinRewards/checkinRewards';


export default /*@__PURE__*/_defineComponent({
  __name: 'checkinRewards',
  props: {
    dataSet: {}
  },
  emits: ['updateInfo', "callCheckinClaim", 'goToVerifyPhoneNum'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const verifyPhoneRef = ref()

const props = __props

const emits = __emit
const checkinRef = ref()


const callCheckinClaim = (configData: any, claimType: number) => {
    emits("callCheckinClaim", configData, claimType)
}

const goToVerifyPhoneNum = (type: any) => {
    emits('goToVerifyPhoneNum', type)
}
const updateInfo = () => {
    emits('updateInfo')
}

const openVerifyPhonePopup = () => {
    verifyPhoneRef.value.open()
}

const checkinOpen = (data: any, value: any) => {
    checkinRef.value.open(data, value)
}
const checkinclose = () => {
    checkinRef.value.close()
}
__expose({
    checkinOpen,
    checkinclose,
    openVerifyPhonePopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.signin_rewards')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.dataSet.bannerIcon,
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.dataSet.hasNotVerifyData)
          ? (_openBlock(), _createBlock(_component_van_row, {
              key: 0,
              class: "claimField"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "18",
                  class: "claimText",
                  style: _normalizeStyle({ opacity: _ctx.dataSet.isPhoneVerified ? 0.2 : 1 })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[1] || (_cache[1] = _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)),
                      _createTextVNode(" R$ " + _toDisplayString(_ctx.dataSet.notVerifyConfig?.reward) + " × " + _toDisplayString(_ctx.dataSet.notVerifyConfig?.days) + " " + _toDisplayString(_ctx.$t('common.days')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('activity.noPhoneVerification')), 1)
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "claimColumn"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.dataSet.isPhoneVerified)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(_ctx.dataSet.isPhoneVerified ? 'disableBtn' : '')
                        }, [
                          _createVNode(_component_van_icon, {
                            name: "checked",
                            size: "25",
                            color: "#f2910d"
                          })
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.dataSet.isShowPhoneVerification && _ctx.dataSet.hasVerifyPhoneData)
          ? (_openBlock(), _createBlock(_component_van_row, {
              key: 1,
              class: "claimField"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "18",
                  class: "claimText",
                  style: _normalizeStyle({ opacity: !_ctx.dataSet.isPhoneVerified ? 0.2 : 1 })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[2] || (_cache[2] = _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)),
                      _createTextVNode(" R$ " + _toDisplayString(_ctx.dataSet.verifyConfig.reward) + " × " + _toDisplayString(_ctx.dataSet.verifyConfig.days) + " " + _toDisplayString(_ctx.$t('common.days')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.$t('activity.phoneVerification')) + " ", 1),
                      (_ctx.dataSet.isPhoneVerified)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('activity.verified')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "claimColumn"
                }, {
                  default: _withCtx(() => [
                    (_ctx.dataSet.isPhoneVerified)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_van_icon, {
                            name: "checked",
                            size: "25",
                            color: "#e151a4"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.dataSet.isPhoneVerified)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "click_btn",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToVerifyPhoneNum(0)))
                        }, _toDisplayString(_ctx.$t('activity.verify')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(CheckinPopup, {
          ref_key: "checkinRef",
          ref: checkinRef,
          onGoToVerify: goToVerifyPhoneNum
        }, null, 512),
        (_ctx.dataSet.activityInfo.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('common.eventRule')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "line_text",
                  key: index
                }, _toDisplayString(item), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(VerifyPhonePopup, {
      ref_key: "verifyPhoneRef",
      ref: verifyPhoneRef,
      onUpdateInfo: updateInfo
    }, null, 512)
  ], 64))
}
}

})